<template>
  <div class="app-root">
    <Preloader v-if="showPreloader" />
    <TheHeader />
    <main class="main">
      <router-view></router-view>
    </main>
    <TheFooter />
  </div>
</template>

<script scoped>
import TheHeader from "@/components/layouts/TheHeader.vue";
import TheFooter from "@/components/layouts/TheFooter.vue";
import Preloader from "@/components/ui/Preloader.vue";

export default {
  name: "App",
  components: {
    TheHeader,
    TheFooter,
    Preloader,
  },
  data() {
    return {
      showPreloader: true,
    };
  },
  mounted() {
    const hide = () => {
      this.showPreloader = false;
    };

    if (document.readyState === "complete") {
      this.$nextTick(hide);
      return;
    }

    window.addEventListener(
      "load",
      () => {
        this.$nextTick(hide);
      },
      { once: true },
    );
  },
};
</script>
